module.exports = __webpack_public_path__ + "img/4170023.b9cd91d8.png";